import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=28f29ad7&"
import script from "./Listagem.vue?vue&type=script&lang=js&"
export * from "./Listagem.vue?vue&type=script&lang=js&"
import style0 from "./Listagem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports